import {Component, OnInit} from '@angular/core';
import {ClientDataServiceService} from "./client-data-service.service";
import {Climate, Climates} from "./climate.model";
import {FilterComponent, FilterExpression} from "@progress/kendo-angular-filter";
import {CompositeFilterDescriptor, filterBy} from "@progress/kendo-data-query";
import {UrlBuilder} from "../url-builder/url.builder";
import {ClientListWithAccess} from "../listclients/clientlistwithaccess";

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.css']
})
export class ClientsComponent implements OnInit {
  public clients: Climate[] = [];
  public filteredClients: Climate[] = [];

  public activeFilter: CompositeFilterDescriptor = {
    logic: 'or',
    filters: [ {"operator":"neq","value":null,"field":"name"} ] // Initial filter value
  }

  public filters: FilterExpression[] = [
    {
      field: "name",
      title: "Klant Nummer",
      editor: "string",

    },
    {
      field: "clientname",
      title: "Klant Naam",
      editor: "string",
    },
    {
      field: "version",
      title: "Version",
      editor: "string",
    },
    {
      field: "revision",
      title: "Revision",
      editor: "string",
    },

  ];

  constructor(private climatsService: ClientDataServiceService) {
  }

  // Fetch the data when the component initializes
  ngOnInit(): void {
    this.climatsService.getClimatsJSON().subscribe((data: Climates) => {

      if(localStorage["service-web-filter"]) {
        var savedFilterValue = JSON.parse(localStorage["service-web-filter"]);
        this.activeFilter = savedFilterValue;
      }
      this.clients = data?.climate || []; // Assign the "climate" list from JSON to 'clients'
      this.clients = ClientListWithAccess.FilterNew(this.clients);
      this.clients.sort((a,b)=> a.name.localeCompare(b.name ));
      this.filteredClients = filterBy(this.clients, this.activeFilter);

      let urlBuilder: UrlBuilder = new UrlBuilder();
      urlBuilder.SetCurrentClient("");
    });
  }

  onFilterChange(newValue: CompositeFilterDescriptor): void {
    localStorage["service-web-filter"] = JSON.stringify(newValue);
    this.filteredClients = filterBy(this.clients, newValue);
  }


  onActivate(computerID: string) {
    // this.expanded = false;
    // this.panel?.toggle();
    let urlBuilder: UrlBuilder = new UrlBuilder();
    urlBuilder.SetCurrentClient(computerID);
    // this.currentClient = urlBuilder.GetCurrentClient();
    console.log('INFO TARGET: ' + urlBuilder.GetCurrentClient());
  }


  ShowFilter():boolean
  {
    return true;
      return (this.clients.length > 10);
  }


  BrokenLink(computer: Climate)  : boolean {
    if(computer.connected) return false;
    // Convert lle_time to a Date object (or use it directly if it's already a number)
    const lleTime = new Date(computer.lle_time);

    // Threshold for 2 days and 8 hours ago
    const tenDaysTenHoursAgo = new Date(Date.now() - ( 2 * 24 * 60 * 60 * 1000) - (8 * 60 * 60 * 1000));

    // If lleTime is bigger, that it is within the threshold. So the computer has recently gone offline
    return lleTime > tenDaysTenHoursAgo;
  }
}
